import { render, staticRenderFns } from "./CpuFunctionDetailModal.vue?vue&type=template&id=681f0b06&scoped=true"
import script from "./CpuFunctionDetailModal.vue?vue&type=script&lang=js"
export * from "./CpuFunctionDetailModal.vue?vue&type=script&lang=js"
import style0 from "./CpuFunctionDetailModal.vue?vue&type=style&index=0&id=681f0b06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_j7knk6mol3vthgvrc443rvn57u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681f0b06",
  null
  
)

export default component.exports